/* FD brand ---------------------------------------------------------------
   Furniture Done header behaviour. Ported from mocks/homepage.html.

   Everything here is progressive enhancement. With JS off the header is still
   sticky, the mega panel still opens on hover/focus, and the first tab's pane
   ships .is-on so the catalogue is still reachable.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  /* ---- 1. compact on scroll ----------------------------------------- */
  var wrap = document.querySelector('.fd-hdr-wrap');
  if (wrap) {
    var syncCompact = function () {
      wrap.classList.toggle('is-compact', window.scrollY > 24);
    };
    syncCompact();
    window.addEventListener('scroll', syncCompact, { passive: true });
  }

  /* ---- 2. mega-menu tab row ------------------------------------------
     Clicking a tab swaps the visible pane; keyboard focus does the same so the
     panel is tabbable. Deliberately NOT wired to mouseenter: the tabs sit in a
     horizontal row, so a pointer travelling diagonally from one tab down to a
     card sweeps across its neighbours and would flip the pane underneath
     itself. The click is suppressed because the tab is a switch, not a
     destination -- each pane carries its own "View all" link. */
  var panels = document.querySelectorAll('.fd-mega');

  var activate = function (panel, key) {
    /* The tabs are links, not a tab widget (see fd-mega-pane.liquid), so the
       state is aria-current — aria-selected has no meaning without role="tab"
       and was being silently ignored. */
    panel.querySelectorAll('.fd-mega-opt').forEach(function (o) {
      var on = o.dataset.fdOpt === key;
      o.classList.toggle('is-on', on);
      if (on) o.setAttribute('aria-current', 'true');
      else o.removeAttribute('aria-current');
      /* aria-expanded rides alongside: the tab controls the pane below it
         (aria-controls in fd-mega-pane.liquid), so the disclosure state has to
         move with the pane, not just the visual class. */
      o.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    panel.querySelectorAll('.fd-mega-pane').forEach(function (p) {
      p.classList.toggle('is-on', p.dataset.fdPane === key);
    });
  };

  panels.forEach(function (panel) {
    panel.querySelectorAll('.fd-mega-opt').forEach(function (opt) {
      var pick = function () {
        activate(panel, opt.dataset.fdOpt);
      };
      opt.addEventListener('focus', pick);
      opt.addEventListener('click', function (event) {
        /* A modified click is a request to open the destination elsewhere --
           new tab, new window, download. Swallowing it would strand the one
           user who wanted the href the tab still legitimately carries. */
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        pick();
      });
    });

    /* ---- 3. the X suppresses the panel until the pointer leaves ------- */
    var closeBtn = panel.querySelector('.fd-mega-x');
    var item = panel.closest('.fd-nav-item');
    if (closeBtn && item) {
      closeBtn.addEventListener('click', function () {
        item.classList.add('is-suppressed');
        closeBtn.blur();
      });
      item.addEventListener('mouseleave', function () {
        item.classList.remove('is-suppressed');
      });
    }
  });

  /* ---- 4. Escape closes whatever panel is open ----------------------- */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    /* :hover is here as well as :focus-within because the panel opens on hover
       alone -- a pointer user who has never focused anything still expects
       Escape to dismiss it. Already-suppressed items are skipped so a second
       Escape does not stack another one-shot mouseleave. */
    /* Every match, not just the first: a pointer can rest on one item while
       focus sits in another, and dismissing only one leaves a panel open. */
    var closed = [];
    var held = null;
    document.querySelectorAll('.fd-nav-item:hover, .fd-nav-item:focus-within').forEach(function (item) {
      if (!item.querySelector('.fd-mega') || item.classList.contains('is-suppressed')) return;
      if (document.activeElement && item.contains(document.activeElement)) held = item;
      item.classList.add('is-suppressed');
      closed.push(item);
      /* focus below re-opens it via :focus-within, so the suppression has to
         outlive this tick and clear on the next pointer exit */
      item.addEventListener(
        'mouseleave',
        function () {
          item.classList.remove('is-suppressed');
        },
        { once: true }
      );
    });
    if (!closed.length) return;
    /* Focus lands on the nav link of whichever item was holding focus, or of
       the first one closed when the panel was opened by hover alone. */
    var landing = held || closed[0];
    if (held && document.activeElement) document.activeElement.blur();
    var trigger = landing.querySelector('.fd-nav-link');
    if (trigger) trigger.focus();
  });

  /* ---- 5. theme editor ------------------------------------------------
     Selecting a tab or card block in the editor has to reveal the panel it
     lives in, otherwise the merchant edits something they cannot see. */
  document.addEventListener('shopify:block:select', function (event) {
    var navItem = event.target.closest('.fd-nav-item');
    if (!navItem) return;
    navItem.classList.remove('is-suppressed');
    navItem.classList.add('is-forced');

    var panel = navItem.querySelector('.fd-mega');
    if (!panel) return;
    var pane = event.target.closest('.fd-mega-pane');
    var key = pane ? pane.dataset.fdPane : event.target.dataset.fdOpt;
    if (key) activate(panel, key);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var navItem = event.target.closest('.fd-nav-item');
    if (navItem) navItem.classList.remove('is-forced');
  });
})();
